module.exports = __webpack_public_path__ + "img/poster_tem_1.915df2b7.png";